import React from "react"
import Showcase from "../components/Showcase"
import { View, Text, Checkbox } from "react-ame-components"

export class CheckboxExample extends React.Component {
  state = {
    option1Checked: true,
    option2Checked: false,
    groupChecked: false,
    t1Checked: false,
    t2Checked: false,
    t3Checked: false,
  }

  handleGroupCheck = e => {
    this.setState({
      groupChecked: e,
      t1Checked: e,
      t2Checked: e,
      t3Checked: e,
    })
  }

  render() {
    return (
      <Showcase
        title="Componente Checkbox"
        description="Este componente mostra caixas de seleção">
        <Text color="neutral-700">
          Este componente serve para exibir uma caixa de seleção. Veja abaixo:
        </Text>
        <View
          paddingTop="medium"
          justify="center"
          direction="column">
          <Checkbox
            id="3124123"
            checked={this.state.option1Checked}
            onChange={e => this.setState({ option1Checked: e.checked })}
            value="value teste">
            <Text>Opção 1</Text>
          </Checkbox>
          <Checkbox
            id="3125123"
            checked={this.state.option2Checked}
            onChange={e => this.setState({ option2Checked: e.checked })}
            value="value teste">
            <Text>Opção 2</Text>
          </Checkbox>
        </View>
        <View
          marginTop="medium"
          marginBottom="medium"
        />
        <View marginBottom="small">
          <Text color="neutral-700">
            Exemplo do componente Check com a propriedade group:
          </Text>
        </View>
        <View
          direction="row"
          align="center">
          <Checkbox
            value="teste"
            group={[
              this.state.t1Checked,
              this.state.t2Checked,
              this.state.t3Checked,
            ]}
            checked={this.state.groupChecked}
            onChange={e => {
              this.handleGroupCheck(e.checked)
            }}>
            <Text> Marque as alternativas:</Text>
          </Checkbox>
        </View>
        <View padding="small">
          <View
            direction="row"
            align="center">
            <Checkbox
              id="545135"
              value="teste1"
              checked={this.state.t1Checked}
              onChange={e => {
                this.setState({
                  t1Checked: e.checked,
                })
              }}>
              <Text>Opção 1</Text>
            </Checkbox>
          </View>
          <View
            direction="row"
            align="center">
            <Checkbox
              id="545168515"
              value="teste2"
              checked={this.state.t2Checked}
              onChange={e => {
                this.setState({
                  t2Checked: e.checked,
                })
              }}>
              <Text>Opção 2</Text>
            </Checkbox>
          </View>
          <View
            direction="row"
            align="center">
            <Checkbox
              id="541248135"
              value="teste3"
              checked={this.state.t3Checked}
              onChange={e => {
                this.setState({
                  t3Checked: e.checked,
                })
              }}>
              <Text>Opção 3</Text>
            </Checkbox>
          </View>
        </View>
      </Showcase>
    )
  }
}
